import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=62e95ee6&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=62e95ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e95ee6",
  null
  
)

export default component.exports